import type { CellClassParams } from 'ag-grid-community';
import type { ColDefField } from 'ag-grid-community/dist/types/core/entities/colDef';
import * as R from 'ramda';

export const historyGetIsChangedStyle =
    <T = any>({ customKey, extraClass }: { customKey?: ColDefField<T>; extraClass?: string } = {}) =>
    (params: CellClassParams<T>) => {
        const { data = {}, column } = params;

        if ('isHeadLine' in data && (data as any)?.isHeadLine) {
            return undefined;
        }

        const cellField = customKey ?? `${column?.getColId()}Cng`;
        const isUpdatedValue = Boolean(R.path(R.split('.', cellField), data));

        return isUpdatedValue ? `updatedRowCell ${extraClass}` : extraClass;
    };
